import { VisibilitaRequestVO } from "./visibilita-requestVO";

export class ModificaVisibilitaRequestVO {
    aggiunte: VisibilitaRequestVO[];
    rimozioni: VisibilitaRequestVO[];
}
